var map = {
	"./aut.svg": 273,
	"./bel.svg": 378,
	"./bgr.svg": 898,
	"./che.svg": 73,
	"./cyp.svg": 575,
	"./cze.svg": 703,
	"./deu.svg": 465,
	"./dnk.svg": 942,
	"./esp.svg": 927,
	"./est.svg": 531,
	"./fin.svg": 368,
	"./fra.svg": 818,
	"./gbr.svg": 644,
	"./grc.svg": 805,
	"./hrv.svg": 427,
	"./hun.svg": 462,
	"./irl.svg": 252,
	"./isl.svg": 84,
	"./ita.svg": 723,
	"./ltu.svg": 106,
	"./lux.svg": 468,
	"./lva.svg": 20,
	"./nld.svg": 609,
	"./nor.svg": 334,
	"./pol.svg": 890,
	"./prt.svg": 809,
	"./rou.svg": 77,
	"./svk.svg": 661,
	"./svn.svg": 432,
	"./swe.svg": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;